/**
 * 支付管理 通知维护
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>通知维护</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索:">
        <el-input size="small" v-model="formInline.word" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="title" label="通知标题" width="200">
      </el-table-column>
      <el-table-column align="center" prop="content" label="通知内容" width="450">
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间" width="200">
      </el-table-column>
      <el-table-column align="center" prop="startTime" label="开始日期" width="200">
      </el-table-column>
      <el-table-column align="center" prop="endTime" label="截止日期" width="200">
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态" width="200">
        <template slot-scope="scope">
          <div>{{scope.row.status =='1'? '有效': '无效'}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="type" label="类型" width="200">
        <template slot-scope="scope">
          <div>{{scope.row.type == '1'? '普通': '紧急'}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="url" label="h5地址" width="400">
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right"  min-width="270">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" v-if="editFormVisible" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="通知标题" prop="title">
          <el-input size="small" v-model="editForm.title" auto-complete="off" placeholder="请输入通知标题"></el-input>
        </el-form-item>
        <el-form-item label="通知内容" prop="content">
          <el-input size="small" type="textarea" v-model="editForm.content" auto-complete="off" placeholder="请输入通知内容"></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker
            v-model="editForm.startTime"
            type="date"
            @change="dateChange($event, 'startTime')"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="截至时间" prop="endTime">
          <el-date-picker
            v-model="editForm.endTime"
            type="date"
            @change="dateChange($event, 'endTime')"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select size="small" v-model="editForm.status" placeholder="请选择" class="userRole">
            <el-option label="无效" :value="0"></el-option>
            <el-option label="有效" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select size="small" v-model="editForm.type" placeholder="请选择" class="userRole">
            <el-option label="普通" :value="1"></el-option>
            <el-option label="紧急" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="h5地址" prop="url">
          <el-input size="small" v-model="editForm.url" auto-complete="off" placeholder="请输入h5地址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div>
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  noticePage, noticeAdd, noticeEdit, vpnVipGet, vpnVipDelete,
} from '../../api/payMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      payType: [
        { key: '现金', value: 1 },
        { key: '支付宝', value: 2 },
        { key: '微信', value: 3 },
        { key: 'POS通', value: 4 },
        { key: '闪付', value: 5 },
        { key: 'POS通C扫B', value: 6 },
        { key: '银联二维码', value: 8 },
        { key: '会员余额支付', value: 9 }
      ],
      editForm: {
        monthNum: '',
        priceSource: '',
        priceDiscount: '',
        title: '',
        type: '',
        timeFlag: '',
        px: '',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        title:[{ required: true, message: '请输入通知标题', trigger: 'blur' }],
        content:[{ required: true, message: '请输入通知时间', trigger: 'blur' }],
        createTime:[{ required: true, message: '请选择创建时间', trigger: 'blur' }],
        startTime:[{ required: true, message: '请选择开始时间', trigger: 'blur' }],
        endTime:[{ required: true, message: '请选择结束时间', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        url:[{ required: true, message: '请输入h5地址', trigger: 'blur' }],
      },
      formInline: {
        pageNo: 0,
        pageSize: 10,
        word:"",
        // varLable: '',
        // varName: '',
        // token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    dateChange(e, type){
      let date = new Date(e)
      let time = this.formatDate(date, 'yyyy-MM-dd')
      this.editForm[type] = time
    },
    formatDate(date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
      let o = {	
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + ''
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str))
        }
      }
      return fmt
    },
    padLeftZero(str) {
      return ('00' + str).substr(str.length)
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      noticePage(parameter)
        .then(res => {
          this.loading = false
          if (res.data.success == false) {
            this.$message({
              type: 'info',
              message: res.data.msg
            })
          } else {
            this.listData = res.data.dataList
            // 分页赋值
            // this.pageparm.currentPage = this.formInline.page
            // this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.totalCount
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNo = parm.currentPage - 1
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.pageNo = 0
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm = JSON.parse(JSON.stringify(row))
      } else {
        this.title = '添加'
        this.editForm = {}
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      if(this.editForm.startTime && this.editForm.endTime){
        // 创建Date对象并设置日期
        const d1 = new Date(this.editForm.startTime);
        const d2 = new Date(this.editForm.endTime);
        if (d1.getTime() > d2.getTime()) {
            this.$message.error('请选择正确的开始/结束时间！')
            return
        }
      }
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.title == '添加'){
            noticeAdd(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '新增成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('新增失败，请稍后再试！')
            })
          }else{
            noticeEdit(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          vpnVipDelete({id: row.id})
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('套餐管理删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    
    keyUser(index, rowItem) {
      vpnVipGet({id: rowItem.id})
        .then(res => {
          this.loading = false
          if (res.data.success == false) {
            this.$message({
              type: 'info',
              message: 'res.data.msg'
            })
          }else{
            this.editFormVisible = true
            let row = res.data
            if (row != undefined && row != 'undefined') {
              this.title = '查看'
              this.editForm.id = row.id
              this.editForm.monthNum = row.monthNum
              this.editForm.priceSource = row.priceSource
              this.editForm.priceDiscount = row.priceDiscount
              this.editForm.title = row.title
              this.editForm.type = row.type
              this.editForm.px = row.px
              this.editForm.timeFlag = row.timeFlag
            }
          }
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/machine/notice.vue